import { render, staticRenderFns } from "./MyCenter.vue?vue&type=template&id=f8444cda&scoped=true&"
import script from "./MyCenter.vue?vue&type=script&lang=js&"
export * from "./MyCenter.vue?vue&type=script&lang=js&"
import style0 from "./MyCenter.vue?vue&type=style&index=0&id=f8444cda&prod&lang=scss&scoped=true&"
import style1 from "./MyCenter.vue?vue&type=style&index=1&id=f8444cda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8444cda",
  null
  
)

export default component.exports